import { useQuery } from '@tanstack/react-query'
import { getCityByCoor } from "../api/get-city-by-coor"

export const useGetCityByCoor = ({ params, options = {} }) => {
  return useQuery({
    queryKey: ['get-city-by-coor', params],
    queryFn: () => getCityByCoor(params),
    ...options
  })
}